/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from 'utils/styles/style_helpers';


/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// STORY PROPERTIES : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    storyproperties: {
        '& .title': {
            marginBottom: 0
        },
        '& .note': {
            marginBottom: pxToEm(6)
        },
        '& .storyurl': {
            transition: 'filter 1s, opacity 1s',
            '& .formelement, .icon': {
                height: pxToEm(32)
            },
            '& .errormessage': {
                whiteSpace: 'pre-line'
            }
        },
        '& .autopopulateToggle': {
            display: 'flex',
            marginBottom: pxToEm(10),
            '& p': {
                display: 'flex',
                extend: theme.typography.size.xxsmall
            },
            '& .toggle': {
                marginLeft: pxToEm(20),
                fontSize: '50%'
            }
        }
    },
    [mediaQuery.customizeRailThin]: {
        storyproperties: {
            '& .errormessage': {
                display: 'flex',
                fontSize: pxToEm(10),
            },
            '& .autopopulateToggle': {
                display: 'block',
                '& .toggle': {
                    margin: `${pxToEm(5)} 0`,
                }
            }
        }
    },
    [mediaQuery.customizeInContentThin]: {
        storyproperties: {
            '&.incontent': {
                extend: {
                    '& .errormessage': {
                        display: 'flex',
                        fontSize: pxToEm(10),
                    },
                    '& .autopopulateToggle': {
                        display: 'block',
                        '& .toggle': {
                            margin: `${pxToEm(5)} 0`,
                        }
                    }
                }
            }
        }
    },
    [mediaQuery.customizeThinnest]: {
        storyproperties: {
            '& .field': {
                display: 'inline',
            }
        }
    }
});